import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { CollezioniPageConfig } from '../configuration'
import VisibilitySensor from '../VisibilitySensor'
import styles from './index.styles'
import AssignId from '../AssignId'
import { LazyVideo } from 'react-lazy-media'
const useStyles = makeStyles(styles)
export default function Collezione() {
	const classes = useStyles()
	const showTitle = false;
	return (
		<div className={classes.root} >
			<AssignId
			absolute
			y='0'
			yMobile='0'
			id={CollezioniPageConfig.id}
			/>
				<h2 className={classes.h1} >{CollezioniPageConfig.title[0]}<br/>{CollezioniPageConfig.title[1]}</h2>
				<p className={classes.p} >{CollezioniPageConfig.secondary}</p>
				<VisibilitySensor index={6} />
				<div className={classes.iframeWrap} >
				<LazyVideo
				autoplay={true} 
				loop={false} 
				muted={true} 
				controls={false} 
				playsinline={true} 
				src={CollezioniPageConfig.videoUrl}
				/>
			</div>
		</div>
	)
}